interface styleConfigProps {
  LabelTextColorControl: {
    from: string,
    modifiers: [['brighter' | 'darker' | 'opacity', number]]
  };
  LabelsFontSizeControl: { value: number };
  LabelsFontFamilyControl: { value: string };
  LabelTranslateX: number;
  LabelTranslateY: number;
  LabelRotationControl: number;
  DotsLabel: {
    color: string,
    fontSize: number,
    fontFamily: string,
  };
}

interface Dt {
  key: string;
  x: number;
  y: number;
  width: number;
  height: number;
  data: Record<string, any>;
}

interface globalConfigProps {
  useGlobalFont: boolean;
  fontLabel: string;
}

interface CustomLabelProps {
  data: Dt[];
  styleConfig: styleConfigProps;
  globalConfig: globalConfigProps;
  content: (dt: Dt['data'], x: number) => React.ReactNode;
}

const CustomLabel = ({
  data, styleConfig, globalConfig, content,
}: CustomLabelProps) => {
  const {
    LabelTranslateX,
    LabelTranslateY,
    LabelRotationControl,
    DotsLabel,
  } = styleConfig;

  return data.map((dt) => (
    <g
      key={dt.key}
      transform={`translate(${dt.x}, ${dt.y})`}
    >
      <text
        textAnchor="middle"
        dominantBaseline="central"
        fillOpacity={1}
        style={{
          fontSize: `${DotsLabel.fontSize ?? 13}px`,
          fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontLabel : DotsLabel.fontFamily}', Arial`,
          transform: `translate(${LabelTranslateX || 0}px, ${LabelTranslateY || 0}px) rotate(${LabelRotationControl || 0}deg)`,
          transformOrigin: 'center center',
          transformBox: 'fill-box',
          pointerEvents: 'none',
          fill: DotsLabel.color,
        }}
      >
        {content(dt.data, 0)}
      </text>
    </g>
  ));
};

export default CustomLabel;
